<template>
  <popupCharge
    :activation="charge"
    v-if="charge"
  />
  <div class="h-auto bg-white w-full pt-6 pb-8 pl-8 pr-8">
    <div class="">
      <div class="all">
        <div
          class="w-full flex text-c16 font-c7 text-left mb-6 text-titre"
        >
          <div class="w-1/4">
            Nom
          </div>
          <div class="w-1/4 ml-4">
            Gérant
          </div>
          <div class="w-1/5 ml-4">
            Catégorie
          </div>
          <div class="w-1/5 ml-4">
            Taille
          </div>
          <div class="w-1/6 ml-4">
            Derniere sauvegarde
          </div>
        </div>

        <div class="diviser" />

        <div
          v-if="charge"
          class="flex justify-center mt-16"
        >
          <easy-spinner
            type="dots"
            size="70"
          />
        </div>

        <div
          class="text-center mt-10"
          v-if="tracker.length === 0 && !charge"
        >
          Aucun commerce pour le moment
        </div>

        <div
          v-for="(item, index) in tracker"
          :key="index"
          class="mt-5"
        >
          <div
            v-if="index > 0"
            class="diviser mt-5"
          />
          <div>
            <liste
              class="mt-5"
              :item="item"
              @selected="selected(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex mt-10 justify-end pb-10 pr-10">
      <div class="w-1/3 flex items-center justify-end">
        <div class="text-c16 font-c6">
          Page {{ page }} sur {{ totalPage }}
        </div>
        <icon
          :data="icons.prev"
          height="50"
          width="50"
          class="icone cursor-pointer ml-4"
          original
          @click="prev"
        />
        <icon
          :data="icons.next"
          height="50"
          width="50"
          class="icone cursor-pointer ml-4"
          original
          @click="next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import arrow from "../../../assets/icons/arrow.svg";
import agenda from "../../../assets/icons/agenda.svg";
import down from "../../../assets/icons/down.svg";
import prev from "../../../assets/icons/prev.svg";
import next from "../../../assets/icons/next.svg";
import liste from "./liste";
import apiroutes from "../../../router/api-routes";
import http from "../../../plugins/https";

export default {
  name: "Index",
  components: { liste },

  props: {
    search: { type: String, default: null },
    filtrage: { type: String, default: null },
  },

  data() {
    return {
      icons: { arrow, agenda, down, prev, next },
      charge: true,
      page: 1,
      limite: 20,
      total: 0,
      totalPage: 0,
      dataClient: [],
      // Séquence pour annuler logiquement les requêtes obsolètes
      reqId: 0,
      // Délai pour la recherche
      searchTimeout: null,
    };
  },

  computed: {
    // Clé de dépendance pour surveiller les changements
    filtersKey() {
      // Ne déclencher la recherche que si search a au moins 3 caractères ou est vide/null
      const searchValue = this.search && this.search.length >= 3 ? this.search : null;
      return `${searchValue || ""}::${this.filtrage || ""}`;
    },
    tracker() {
      this.$emit("stat", `${this.dataClient.length} / ${this.total}`);
      return this.dataClient;
    },
  },

  watch: {
    // Surveillance des props search avec debounce
    search: {
      handler(newVal) {
        // Clear le timeout précédent
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        
        // Si moins de 3 caractères et pas vide, ne pas chercher
        if (newVal && newVal.length > 0 && newVal.length < 3) {
          return;
        }
        
        // Débounce de 300ms pour éviter trop de requêtes
        this.searchTimeout = setTimeout(() => {
          this.resetToFirstPage();
        }, 300);
      },
    },
    
    // Surveillance du filtrage
    filtrage: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log('Filtrage changé:', { ancien: oldVal, nouveau: newVal });
        this.resetToFirstPage();
      },
    },
    
    // La pagination déclenche le fetch
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.allClientParginate();
      }
    },
  },

  created() {
    // Chargement initial
    this.allClientParginate();
  },

  beforeUnmount() {
    // Nettoyer le timeout si le composant est détruit
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },

  methods: {
    prev() {
      if (this.page > 1) this.page -= 1;
    },
    
    next() {
      if (this.page < this.totalPage) this.page += 1;
    },

    // Réinitialiser à la page 1 et relancer la recherche
    resetToFirstPage() {
      if (this.page !== 1) {
        this.page = 1;
      } else {
        this.allClientParginate();
      }
    },

    // Nettoyage d'objet (évite d'envoyer des champs vides)
    _clean(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([, v]) => v !== null && v !== "" && v !== undefined
        )
      );
    },

    async allClientParginate() {
      this.charge = true;

      // Validation de la recherche : au moins 3 caractères ou vide/null
      let searchValue = null;
      if (this.search) {
        if (this.search.length >= 3) {
          searchValue = this.search.trim();
        } else {
          // Si moins de 3 caractères, on ignore la recherche
          searchValue = null;
        }
      }

      let body = {
        limit: this.limite,
        page: this.page,
        search: searchValue,
        categorie: this.filtrage,
      };

      // Debug pour voir ce qui est envoyé
      console.log('Paramètres envoyés:', body);

      // Si filtrage = "TOUT" ou null/undefined, on ne l'envoie pas
      if (!body.categorie || body.categorie === "TOUT" || body.categorie === "Catégorie") {
        delete body.categorie;
      }

      // Nettoyage des champs vides
      body = this._clean(body);

      console.log('Paramètres après nettoyage:', body);

      const myReq = ++this.reqId;

      try {
        const response = await http.post(
          apiroutes.baseURL + apiroutes.allCommerceParginate,
          body
        );

        // Vérifier que cette requête n'est pas obsolète
        if (myReq !== this.reqId) return;

        const data = response?.data || response; // Adapter selon votre structure de réponse
        const rows = data?.rows || [];
        const count = Number(data?.count || 0);

        console.log('Réponse reçue:', { rows: rows.length, count, filtrage: this.filtrage });

        this.dataClient = rows;
        this.total = count;
        this.totalPage = Math.max(1, Math.ceil(count / this.limite));
        
      } catch (e) {
        console.error('Erreur lors de la récupération des données:', e);
        
        // En cas d'erreur, réinitialiser les données
        if (myReq === this.reqId) {
          this.dataClient = [];
          this.total = 0;
          this.totalPage = 1;
        }
      } finally {
        if (myReq === this.reqId) {
          this.charge = false;
        }
      }
    },

    selected(item) {
      this.$store.dispatch("saveCompany", item);
      this.$router.push("commerceDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: transparent;
}
.filtr {
  background: rgba(242, 245, 249, 0.5);
  border: 0.5px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 5px;
  height: 36.39px;
}
.compFiltre {
  width: auto;
  min-width: 9.1%;
}
.diviser {
  height: 0.5px;
  background-color: #dddddd;
}
</style>